import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import { canAccess } from '@/mixins/permission';
import admin from '@/admin/routes';
import myAccount from './routes/myAccount';
import resume from './routes/resume';
import post from './routes/post';
import main from './routes/main';
import page from './routes/page';

Vue.use(VueRouter);

const routes = [
  {
    path: '',
    component: () => import('@/layouts/Layout'),
    children: [
      {
        path: '',
        component: () => import('@/layouts/App'),
        children: [
          ...main,
          ...myAccount,
          ...resume,
          ...post,
          ...page,
        ],
      },
    ],
  },
  {
    path: '',
    component: () => import('@/layouts/SSOLayout'),
    children: [
      {
        path: '',
        component: () => import('@/layouts/App'),
        children: [
          {
            path: 'Login',
            component: () => import('@/pages/auth/Login'),
            name: 'login'
          },
          {
            path: 'logout',
            component: () => import('@/pages/auth/Logout'),
            name: 'logout'
          },
          {
            path: 'register',
            component: () => import('@/pages/auth/Register'),
            name: 'register',
          },
          {
            path: 'forget-password',
            component: () => import('@/pages/auth/ForgetPassword'),
            name: 'forgetPassword',
          },
          {
            path: 'user',
            component: () => import('@/pages/users/Index'),
            name: 'user.index'
          },
          {
            path: 'verify/:token',
            component: () => import('@/pages/auth/VerifyEmail'),
            name: 'auth.VerifyEmail',
            props: true,
          },
          {
            path: 'reset-password/:token',
            component: () => import('@/pages/auth/ResetPassword'),
            name: 'auth.resetPassword',
            props: true,
          },
        ]
      },
    ],
  },
  admin,
  {
    path: '*',
    redirect: { name: 'home' },
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeEach(async (to, from, next) => {
  router.app.$nextTick(() => router.app.$loading.start());
  if (to.fullPath.indexOf('/admin') > -1) {
    if (!router.app.$store.getters['user/ready']) {
      await router.app.$store.dispatch('user/fetch');
    }
    if (to.meta.auth && !canAccess(to.fullPath)) {
      next({ name: 'admin.errors.403' });
      return;
    }
  }
  next();
});

router.afterEach(async (to, from) => {
  if (to.matched.length > 2 && from.matched.length > 2) {
    if (to.matched[2].meta.breadcrumb !== from.matched[2].meta.breadcrumb) {
      store.commit('pagination/reset');
    }
  } else {
    store.commit('pagination/reset');
  }
  if (to.meta.auth) {
    store.dispatch('user/fetch');
  }
  await router.app.$nextTick();
  router.app.$loading.finish();
});

Vue.$router = router;
export default router;
